// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoInput_wrapper__3V4XI","input":"VideoInput_input__VsmAw","placeholder":"VideoInput_placeholder__12jgm","icon":"VideoInput_icon__3GEgS"};